import React, { useState, useEffect } from "react";
import "./Property.css";
import CategoriesNav from "../categoriesNav/categoriesNav";
import { fetchData } from "../../Api/dataApi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Property = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const result = await fetchData("Property");
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  }, []);

  return (
    <div className="Property">
      <CategoriesNav />
      <h2 className="Property-title">{t("available_property")}</h2>

      {loading && <p>{t("loading")}</p>}
      {error && (
        <p style={{ color: "red" }}>
          {t("error_message")}: {error}
        </p>
      )}

      <div className="Property-container">
        {data.length === 0 && !loading && <p>{t("no_equipment")}</p>}

        {data.map((Property) => (
          <div key={Property.id || Property._id} className="Property-card">
            <Link to={`/product/${Property.id || Property._id}`}>
              <img
                src={
                  Array.isArray(Property.images) && Property.images.length > 0
                    ? Property.images[0]
                    : t("no_image")
                }
                alt={Property.title || t("no_name")}
                className="Property-image"
              />
            </Link>
            <div className="Property-content">
              <h3 className="Property-name">
                {truncateText(Property.title || t("no_name"), 6)}
              </h3>
              <p className="Property-description">
                {truncateText(Property.description || t("no_description"), 6)}
              </p>
              <p className="Property-price">
                {t("price")}: {Property.price || t("no_price")}
              </p>
              <p className="Property-location">
                {t("location")}: {Property.location || t("no_location")}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Property;
